import type { IconNode } from '../types';

/**
 * @name copy-down
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNCAxNmEyIDIgMCAwIDEtMi0yVjRhMiAyIDAgMCAxIDItMmgxMGEyIDIgMCAwIDEgMiAyIiAvPgogIDxyZWN0IHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgeD0iOCIgeT0iOCIgcng9IjIiIC8+CiAgPHBhdGggZD0iTTE1IDEydjYiIC8+CiAgPHBhdGggZD0ibTEyIDE1IDMgMyAzLTMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/copy-down
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const copyDown: IconNode = [
  ['path', { d: 'M4 16a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2', key: '1qd6ae' }],
  ['rect', { width: '14', height: '14', x: '8', y: '8', rx: '2', key: 'oyuw8j' }],
  ['path', { d: 'M15 12v6', key: '18bv57' }],
  ['path', { d: 'm12 15 3 3 3-3', key: '9mwb31' }],
];

export default copyDown;
